import { string, object, array, mixed} from "yup";
import { messages } from "../../../../utils/messages";
import {
  PROMO_ID_NAME_REGEX,
  PROMO_POSITION_REGEX,
} from "../../../../business/keys";
import { currencyCode } from "./product";
import customVariablesShape from "../../custom";

// Structure of a single promotion object
const singlePromotionItemShape = object().shape({
  id: string()
    .required()
    .matches(
      PROMO_ID_NAME_REGEX,
      "The ID is not a valid ID for this promotion."
    ),
  name: string()
    .required()
    .matches(
      PROMO_ID_NAME_REGEX,
      "The name is not valid for this promotion."
    ),
  creative: string().ensure(),
  position: string().matches(
    PROMO_POSITION_REGEX,
    "The position is not valid for this promotion."
  ),
  custom: object()
    .shape(customVariablesShape)
    .noUnknown(messages.NO_UNKNOWN),
});

// Export promotion schemas
export const promotionShape = object()
  .shape({
    currencyCode,
    
    promotion: mixed().when('promotions', {
      is: (val) => val && Array.isArray(val) && val.length > 0,
      then: (schema) => schema.nullable().optional(), 
      otherwise: singlePromotionItemShape.required(), 
    }),
    
    promotions: array().of(singlePromotionItemShape).nullable().optional(),
  })
  .test(
    'at-least-one-promotion',
    "Must provide either a 'promotion' object or a 'promotions' array.",
    (value) => !!value.promotion || (value.promotions && value.promotions.length > 0)
  )
  .noUnknown(messages.NO_UNKNOWN);